import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const buildCDNImageUrl = (
  image: string,
  size: PRODUCT_IMAGE_SIZE = PRODUCT_IMAGE_SIZE.FULL,
) => {
  if (!image) return '';
  if (typeof image !== 'string') return '';
  if (image.startsWith('http://') || image.startsWith('https://') || image.startsWith('data:')) {
    return image;
  }

  const cdnEndpoint = (process.env.NEXT_PUBLIC_PIK_CDN_ENDPOINT || '').replace(/\/+$/, '');
  const cleanImage = image.startsWith('/') ? image : `/${image}`;
  const formattedImage = cleanImage.endsWith('.webp')
    ? cleanImage.replace('.webp', `-${size}.webp`)
    : cleanImage;

  if (!cdnEndpoint) {
    return formattedImage;
  }

  return decodeURIComponent(`${cdnEndpoint}${formattedImage}`);
};

export const buildSectionImageUrl = (
  image: string,
  size: PRODUCT_IMAGE_SIZE = PRODUCT_IMAGE_SIZE.FULL,
) => {
  return buildCDNImageUrl(image, size);
};
export enum PRODUCT_IMAGE_SIZE {
  SMALL = 'SxS',
  MEDIUM = 'MxM',
  LARGE = 'LxL',
  FULL = PRODUCT_IMAGE_SIZE.LARGE,
}
